<template>
    <b-modal ref="mdlSoggettoAltriIndirizziEdit" size="xl" :title="titoloModale" no-close-on-backdrop no-close-on-esc centered scrollable>
        <div class="sa-tab-scroll">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <span class="sa-label-data">Codice azienda</span>
                    <b-form-input v-model="jsonDataAltriIndirizzi.codiceAzienda"> </b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <span class="sa-label-data">Descrizione</span>
                    <b-form-input v-model="jsonDataAltriIndirizzi.altriIndirizziDescrizione"></b-form-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <span class="sa-label-data">Indirizzo</span>
                    <b-form-input v-model="jsonDataAltriIndirizzi.altriIndirizziIndirizzo"></b-form-input>
                </b-col>

                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <span class="sa-label-data">Cap</span>
                    <b-form-input v-model="jsonDataAltriIndirizzi.altriIndirizziCap"></b-form-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" md="6">
                    <span class="sa-label-data">Regione</span>
                    <b-form-select v-model="jsonDataAltriIndirizzi.codiceIstatRegione" :options="regioniOptions" value-field="codiceIstat" text-field="regione" />
                </b-col>

                <b-col cols="12" md="6">
                    <span class="sa-label-data">Provincia</span>
                    <b-form-select v-model="jsonDataAltriIndirizzi.altriIndirizziProvincia" :options="provinceOptions" value-field="sigla" text-field="provincia" :disabled="!jsonDataAltriIndirizzi.codiceIstatRegione" />
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="12" md="6">
                    <span class="sa-label-data">Comune (Località)</span>
                    <b-form-select v-model="jsonDataAltriIndirizzi.altriIndirizziLocalita" :options="comuniOptions" value-field="codiceIstat" text-field="comune" :disabled="!jsonDataAltriIndirizzi.altriIndirizziProvincia" />
                </b-col>
            </b-row>
        </div>
        <template #modal-footer>
            <b-button size="md" variant="outline-secondary" @click="onClickIndietro"> Annulla </b-button>

            <!--<b-button size="md" variant="outline-danger" @click="onClickAnnulla"> Annulla </b-button>-->

            <b-button variant="outline-success" @click="onSalvaAltriIndirizzi"> Salva Indirizzo </b-button>
        </template>
    </b-modal>
</template>
<script>
import UtilityMixin from "../../utility/UtilityMixin";

export default {
    mixins: [UtilityMixin],
    name: "ContabilitaSoggettoAltriIndirizziModalEditComponent",

    data() {
        return {
            isInitializing: false,
            isEdit: false,

            titoloModale: "Modifica Altri Indirizzi",

            jsonDataAltriIndirizzi: {
                id: null,
                idSoggetto: null,
                codiceAzienda: "",
                altriIndirizziDescrizione: "",
                altriIndirizziIndirizzo: "",
                altriIndirizziCap: "",
                codiceIstatRegione: null,
                regione: "",
                altriIndirizziProvincia: null,
                altriIndirizziLocalita: null,
            },

            regioniOptions: [{ codiceIstat: null, regione: "- Seleziona Regione -" }],
            provinceOptions: [{ sigla: null, provincia: "- Seleziona Provincia -" }],
            comuniOptions: [{ codiceIstat: null, comune: "- Seleziona Comune -" }],

            pathResource: "/contabilitasoggettoaltriindirizzi",
        };
    },

    watch: {
        "jsonDataAltriIndirizzi.codiceIstatRegione"(newVal, oldVal) {
            if (this.isInitializing || newVal === oldVal) return;
            this.resetAfterRegioneChange();
            if (newVal) this.loadProvinceByRegione(newVal);
        },

        "jsonDataAltriIndirizzi.altriIndirizziProvincia"(newVal, oldVal) {
            if (this.isInitializing || newVal === oldVal) return;
            this.resetAfterProvinciaChange();
            if (newVal) this.loadComuniByProvincia(newVal);
        },
    },

    methods: {
        show(item, isEdit) {
            this.isEdit = !!isEdit;
            this.isInitializing = true;

            this.provinceOptions = [{ sigla: null, provincia: "- Seleziona Provincia -" }];
            this.comuniOptions = [{ codiceIstat: null, comune: "- Seleziona Comune -" }];

            if (!this.isEdit) {
                this.titoloModale = "Aggiungi Altri Indirizzi";
                this.jsonDataAltriIndirizzi = {
                    id: null,
                    idSoggetto: item?.idSoggetto ?? null,
                    codiceAzienda: "",
                    altriIndirizziDescrizione: "",
                    altriIndirizziIndirizzo: "",
                    altriIndirizziCap: "",
                    codiceIstatRegione: null,
                    regione: "",
                    altriIndirizziProvincia: null,
                    altriIndirizziLocalita: null,
                };

                this.loadRegioniOptions();

                this.$nextTick(() => {
                    this.isInitializing = false;
                    this.$refs.mdlSoggettoAltriIndirizziEdit.show();
                });

                return;
            }

            this.titoloModale = "Modifica Altri Indirizzi";
            this.jsonDataAltriIndirizzi = { ...item };

            this.loadRegioniOptions();

            if (this.jsonDataAltriIndirizzi.codiceIstatRegione) {
                this.loadProvinceByRegione(this.jsonDataAltriIndirizzi.codiceIstatRegione);
            }

            if (this.jsonDataAltriIndirizzi.altriIndirizziProvincia) {
                this.loadComuniByProvincia(this.jsonDataAltriIndirizzi.altriIndirizziProvincia);
            }

            this.$nextTick(() => {
                this.isInitializing = false;
                this.$refs.mdlSoggettoAltriIndirizziEdit.show();
            });
        },

        onClickIndietro() {
            this.$refs.mdlSoggettoAltriIndirizziEdit.hide();
        },

        resetAfterRegioneChange() {
            this.jsonDataAltriIndirizzi.altriIndirizziProvincia = null;
            this.jsonDataAltriIndirizzi.altriIndirizziLocalita = null;
            this.provinceOptions = [{ sigla: null, provincia: "- Seleziona Provincia -" }];
            this.comuniOptions = [{ codiceIstat: null, comune: "- Seleziona Comune -" }];
        },

        resetAfterProvinciaChange() {
            this.jsonDataAltriIndirizzi.altriIndirizziLocalita = null;
            this.comuniOptions = [{ codiceIstat: null, comune: "- Seleziona Comune -" }];
        },

        loadRegioniOptions() {
            UtilityMixin.methods.loadDataResources("/regioni", {}, this.loadRegioniOptionsSuccess, this.loadRegioniOptionsError);
        },

        loadRegioniOptionsSuccess(response) {
            const base = [{ codiceIstat: null, regione: "- Seleziona Regione -" }];
            const list = response.data.data?.list || response.data.data || [];
            this.regioniOptions = [...base, ...list];
        },

        loadRegioniOptionsError(error) {
            console.log("Errore caricamento regioni:", error);
        },

        loadProvinceByRegione(codiceIstatRegione) {
            UtilityMixin.methods.loadDataResources("/province", { regione: codiceIstatRegione }, this.loadProvinceByRegioneSuccess, this.loadProvinceByRegioneError);
        },

        loadProvinceByRegioneSuccess(response) {
            let base = [{ sigla: null, provincia: "- Seleziona Provincia -" }];
            let list = response.data.data?.list || response.data.data || [];
            this.provinceOptions = [...base, ...list];
        },

        loadProvinceByRegioneError(error) {
            console.log("Errore caricamento province:", error);
        },

        loadComuniByProvincia(siglaProvincia) {
            UtilityMixin.methods.loadDataResources("/comuni/provincia/" + siglaProvincia, {}, this.loadComuniByProvinciaSuccess, this.loadComuniByProvinciaError);
        },

        loadComuniByProvinciaSuccess(response) {
            let base = [{ codiceIstat: null, comune: "- Seleziona Comune -" }];
            let list = response.data.data?.list || response.data.data || [];
            this.comuniOptions = [...base, ...list];
        },

        loadComuniByProvinciaError(error) {
            console.log("Errore caricamento comuni:", error);
        },

        onSalvaAltriIndirizzi() {
            UtilityMixin.methods.saveResource(this.pathResource, this.jsonDataAltriIndirizzi, this.loadDataAltriIndirizziSuccess, this.loadDataAltriIndirizziError);
        },

        loadDataAltriIndirizziSuccess() {
            this.$bvModal.msgBoxOk("Altri indirizzi salvati con successo.", {
                title: "Salvataggio completato",
                size: "sm",
                okVariant: "success",
                centered: true,
            });

            this.$refs.mdlSoggettoAltriIndirizziEdit.hide();
            this.$emit("afterSave");
        },

        loadDataAltriIndirizziError(error) {
            console.log("Errore nel salvataggio degli altri indirizzi:", error?.response?.data?.messaggio || error);
        },
    },
};
</script>
